export const AuthorizationErrorSolaredgeTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-25 rounded text-gray-700">
        <h4 className="font-semibold">For SolarEdge Systems:</h4>
        <p className="my-4 italic">
            Authorization errors from SolarEdge are most often caused by the submission of a limited scope API
            key that only grants Solar Insure access to one individual site, instead of an entire fleet. To
            resolve this issue, please follow these steps:
        </p>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                Log into <a
                    href="https://monitoring.solaredge.com/solaredge-web/p/login"
                    className="text-primary-700 underline"
                    target="_blank"
                    rel="noreferrer"
                >monitoring.solaredge.com.</a>
            </li>
            <li>Click on 'Monitoring Admin' and select 'My Account'.</li>
            <li>
                Navigate to the 'Company Details' tab, scroll down, and click the checkbox indicating
                you have read, understood, and agreed to the SolarEdge API T&C.
            </li>
            <li>Generate and Copy the API Key.</li>
            <li>Click the Save button.</li>
            <li>Login to Solar Insure.</li>
            <li>Click on your avatar in the top right corner and select 'Profile'.</li>
            <li>Go to the 'Integrations' tab.</li>
            <li>Open the section for SolarEdge.</li>
            <li>Replace the existing API key with the newly generated key from SolarEdge.</li>
            <li>Save the changes.</li>
            <li>Click on the refresh monitoring button to initiate a new attempt to pull monitoring data.</li>
        </ul>
    </div>
